import axios from "axios";
import { getToken } from "./auth";

const apiSSO = axios.create({
  baseURL: "http://127.0.0.1:333322"
});

const api = axios.create({
  baseURL: "http://127.0.0.1:333322"
});

api.interceptors.request.use(async config => {
  const token = getToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default api;